"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ViewportProvider = require("./ViewportProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Viewport = function Viewport(_ref) {
  var children = _ref.children,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large;
  var breakpoints = {
    small: small,
    medium: medium,
    large: large
  };
  return _react.default.createElement(_ViewportProvider.ViewportContext.Consumer, null, function (viewport) {
    return breakpoints[viewport] ? children : null;
  });
};

Viewport.propTypes = {
  children: _propTypes.any.isRequired,
  small: _propTypes.bool,
  medium: _propTypes.bool,
  large: _propTypes.bool
};
Viewport.Context = _ViewportProvider.ViewportContext;
/** DEPRECATED:
 * This component is not need anymore since it can be used as `Viewport.Context.Provider`
 */

Viewport.Provider = _ViewportProvider.ViewportContext.Provider;
var _default = Viewport;
exports.default = _default;
Viewport.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Viewport",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "medium": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};